import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import { analytics, EVENT_NAMES } from '../services/Analytics/Analytics'

interface UseUnsavedUploadsWarningProps {
  hasPendingUploads: boolean
}

export default function useUnsavedUploadsWarning({
  hasPendingUploads,
}: UseUnsavedUploadsWarningProps) {
  const location = useLocation()
  const pathnameRef = useRef(location.pathname)

  pathnameRef.current = location.pathname

  useEffect(() => {
    if (!hasPendingUploads) {
      return
    }

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      analytics.track(EVENT_NAMES.UNSAVED_UPLOADS_WARNING_DISPLAYED, {
        Source: pathnameRef.current,
        Type: 'beforeunload',
      })

      event.preventDefault()
      // returnValue is deprecated but required for beforeunload to work in all browsers
      // @ts-ignore - returnValue is deprecated but required
      event.returnValue = ''
      // @ts-ignore - returnValue is deprecated but required
      return event.returnValue
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [hasPendingUploads])
}
